import React from 'react';
import './css/Tooltip.css';

const Tooltip = ({ text, children }) => {
    return (
        <div className="toolTip">
            {children}
            <span className="tooltip-text">{text}</span>
        </div>
    );
};

export default Tooltip;